/** Política de numeración del tenant para una entidad (ADR-002). */
import { mobileApiClient } from './mobileApiClient';

export type SequencePolicy = {
  entity_code: string;
  mode: 'auto' | 'manual';
  prefix?: string | null;
  padding: number;
  include_year: boolean;
  next_code?: string | null;
  message?: string | null;
};

export const sequenceService = {
  async policy(entityCode: string): Promise<SequencePolicy> {
    const { data } = await mobileApiClient.get(
      `/api/v1/sequence-settings/${entityCode}/policy`,
    );
    return data as SequencePolicy;
  },
};
